import { snakeCase } from 'lodash'
import EmitAction from '@/directives/emit-action.directive'

const CLICK_EVENT = 'click'
const DOUBLE_CLICK_EVENT = 'dblclick'

const SUPPORTED_EVENTS = [CLICK_EVENT, DOUBLE_CLICK_EVENT]

function _getContextData(attrs) {
  const ahaAttributes = {}

  for (let i = 0; i < attrs.length; i++) {
    const attr = attrs[i]

    // Check if the attribute starts with 'aha-'
    if (attr.name.startsWith('aha-')) {
      // Remove the 'aha-' prefix and add to the object
      const key = attr.name.slice(4) // Remove 'aha-' from the key
      ahaAttributes[snakeCase(key)] = attr.value // Assign the value to the object
    }
  }

  return ahaAttributes
}

function _getCallbackKey(event) {
  return `aha-click-callback-${event}`
}

export default {
  bind(el, binding, vnode) {
    const contextData = {
      value: _getContextData(el.attributes),
    }
    SUPPORTED_EVENTS.forEach((eventName) => {
      const callback = (e) => {
        // check if binding value is a function
        if (typeof binding.value === 'function') {
          binding.value(e)
          // update the context data
          contextData.value = _getContextData(el.attributes)
        }
      }
      el.addEventListener(eventName, callback, true)
      el[_getCallbackKey(eventName)] = callback
    })

    // get all attributes and its value with prefix 'aha-' and put it into the object
    // simulate the vue binding data to override the default value
    EmitAction.bind(el, contextData, vnode)
  },
  unbind(el, binding, vnode) {
    EmitAction.unbind(el, binding, vnode)
    SUPPORTED_EVENTS.forEach((event) => {
      el.removeEventListener(event, el[_getCallbackKey(event)], true)
    })
  },
}
